export const PRODUCT_ABBREVIATION = "ba";
export const PUBLISHER = "Baana";
